module.exports = __webpack_public_path__ + "img/back_33.87d16b51.svg";